import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { ArrowRight, ArrowLeft } from 'lucide-react';
import PageShell from './PageShell';

import cocoonCover from '../../images/projects/coccon/cocoon-cover.png';
import perchCover from '../../images/projects/graphics/perch-cover.png';
import drizzelCover from '../../images/projects/drizzel/drizzel-cover.png';
import trueriseCover from '../../images/projects/Truerise/Truerise-cover.png';

// AI CREATIVE COVERS
import lcCover from '../../images/projects/ai-project-3/coverimages/LC.png';
import dnkCover from '../../images/projects/ai-project-3/coverimages/DNK.png';
import philipsCover from '../../images/projects/ai-project-3/coverimages/PHILIPS.png';

const categoryMeta = {
  'graphic-design': {
    title: 'GRAPHIC DESIGN',
    heading: 'Graphic Design',
    tagline: 'Print, Branding, Editorial & Visual Identity',
  },

  'ui-ux': {
    title: 'UI / UX DESIGN',
    heading: 'UI / UX Design',
    tagline: 'Websites, Mobile Apps & Digital Experiences',
  },

  'ai-creative': {
    title: 'AI CREATIVE',
    heading: 'AI Creative',
    tagline: 'AI Art, Generative Visuals & Experimental Design',
  },
};

const projectsData = {
  'graphic-design': [
    {
      number: 1,
      title: 'Perch',
      image: perchCover,
      path: '/graphic-design/project-1',
      alt: 'Perch',
    },
    {
      number: 2,
      title: 'Drizzel',
      image: drizzelCover,
      path: '/graphic-design/project-2',
      alt: 'Drizzel',
    },
  ],

  'ui-ux': [
    {
      number: 1,
      title: 'Cocoon',
      image: cocoonCover,
      path: '/ui-ux/project-1',
      alt: 'Cocoon',
    },
    {
      number: 2,
      title: 'Truerise',
      image: trueriseCover,
      path: '/ui-ux/project-2',
      alt: 'Truerise',
    },
  ],

  'ai-creative': [
    {
      number: 1,
      title: 'Mastercard',
      image: lcCover,
      path: '/ai-creative/project-1',
      alt: 'Mastercard',
    },
    {
      number: 2,
      title: 'Dot & Key',
      image: dnkCover,
      path: '/ai-creative/project-2',
      alt: 'Dot & Key',
    },
    {
      number: 3,
      title: 'Philips',
      image: philipsCover,
      path: '/ai-creative/project-3',
      alt: 'Philips',
    },
  ],
};

const CategoryPage = () => {
  const location = useLocation();
  const category = location.pathname.split('/').filter(Boolean)[0];
  const navigate = useNavigate();
  const meta = categoryMeta[category];

  if (!meta) {
    return (
      <PageShell>
        <h1 className="font-serif-display text-[36px] sm:text-[42px]">
          Page Not Found
        </h1>
      </PageShell>
    );
  }

  const projects = projectsData[category] || [];

  return (
    <PageShell>

      {/* CATEGORY HEADER */}
      <div className="border-b-2 divider-line pb-8 mb-8 sm:mb-10">

        <button
          onClick={() => {
            navigate('/');
            window.scrollTo({
              top: 0,
              behavior: 'auto',
            });
          }}
          className="inline-flex items-center gap-2 text-[9px] sm:text-[10px] tracking-[0.25em] sm:tracking-[0.28em] font-sans-ui text-[#1a1a1a] link-underline"
        >
          <ArrowLeft size={12} />
          BACK TO HOME
        </button>

        <p className="text-[10px] sm:text-[11px] tracking-[0.25em] sm:tracking-[0.28em] font-sans-ui text-[#8b2331] mt-6">
          CATEGORY
        </p>

        <h1 className="font-serif-display text-[42px] sm:text-[52px] md:text-[64px] leading-[0.95] mt-3 text-[#0f0f0f]">
          {meta.heading}
        </h1>

        <p className="font-serif-body italic text-[16px] sm:text-[18px] leading-relaxed text-[#2a2a2a] mt-3">
          {meta.tagline}
        </p>

      </div>

      {/* PROJECTS */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-6 lg:gap-8">

        {projects.map((project) => (
          <Link
            key={project.number}
            to={project.path}
            onClick={() =>
              window.scrollTo({
                top: 0,
                behavior: 'auto',
              })
            }
            className="category-card group block"
          >

            {/* PROJECT IMAGE */}
            <div className="relative w-full h-[280px] sm:h-[250px] lg:h-[260px] overflow-hidden bg-[#e8e2d3] border border-[#1a1a1a]">

              <div className="category-image w-full h-full">
                <img
                  src={project.image}
                  alt={project.alt}
                  className="w-full h-full object-cover"
                />
              </div>

            </div>

            {/* PROJECT INFORMATION */}
            <div className="mt-4 flex items-start justify-between gap-4">

              <div className="min-w-0">

                <p className="text-[9px] sm:text-[10px] tracking-[0.25em] sm:tracking-[0.28em] font-sans-ui text-[#8b2331]">
                  PROJECT NO. {String(project.number).padStart(2, '0')}
                </p>

                <p className="font-serif-display text-[21px] sm:text-[22px] leading-tight text-[#0f0f0f] mt-1">
                  {project.title}
                </p>

              </div>

              <ArrowRight
                size={16}
                className="shrink-0 mt-2 text-[#1a1a1a] group-hover:translate-x-1 transition-transform"
              />

            </div>

          </Link>
        ))}

      </div>

    </PageShell>
  );
};

export default CategoryPage;